import React from "react";
import ReactDOM from "react-dom";
import { Segment, Header, Message, Placeholder, Grid, Button, DropdownItemProps, Modal, Form, TransitionablePortal, Tab, Icon, Label, Loader, Checkbox, Radio } from "semantic-ui-react";
import Result from "../../../../../../common/repository/Result";
import { toast } from "../../../../../common/Toast";
import { InvestigatorCaseOutcomeInputValue } from "../InvestigatorCaseOutcomeInput";
import AllocatedInvestigator from "../../../../../../models/AllocatedInvestigator";
import InvestigatorCard from "./InvestigatorCard";
import constants from "../../../../../../common/constants";
import CaseTypeRepository from "../../../../../../common/repository/CaseTypeRepository";
import CaseType from "../../../../../../models/CaseType";
import CompleteCase from "../../../../../../models/CompleteCase";
import ClientRepository from "../../../../../../common/repository/ClientRepository";
import Client from "../../../../../../models/Client";
import CaseOptionalFieldsInputForm from "./CaseOptionalFieldsInputForm";
import CaseRepository from "../../../../../../common/repository/CaseRepository";
import RequirePermission from "../../../../../base/RequirePermission";
import permissions from "../../../../../../common/permissions";
import CaseService from "../../../../../../models/CaseService";
import CaseServiceData from "../../../../../../models/CaseServiceData";
import AttendentInfoDataTable from "./CaseServiceDetailsTable/AttendentInfoDataTable";
import AttendentInfoData from "../../../../../../models/CaseServiceData/AttendentInfoData";
import DoctorPathologistsData from "../../../../../../models/CaseServiceData/DoctorPathologistsData";
import HospitalInfrastructureData from "../../../../../../models/CaseServiceData/HospitalInfrastructureData";
import InsuredInfoData from "../../../../../../models/CaseServiceData/InsuredInfoData";
import TreatingDoctorsData from "../../../../../../models/CaseServiceData/TreatingDoctorsData";
import DoctorPathologistsDataTable from "./CaseServiceDetailsTable/DoctorPathologistsDataTable";
import HospitalInfrastructureDataTable from "./CaseServiceDetailsTable/HospitalInfrastructureDataTable";
import InsuredInfoDataTable from "./CaseServiceDetailsTable/InsuredInfoDataTable";
import TreatingDoctorsDataTable from "./CaseServiceDetailsTable/TreatingDoctorsDataTable";
import RepudiationGround from "../../../../../../models/RepudiationGround";
import RepudiationGroundRepository from "../../../../../../common/repository/RepudiationGroundRepository";
import QCData from "../../../../../../models/QCData";
import URLResource from "../../../../../../models/URLResource";
import FilesPopup from "../../FilesPopup";
import PushBackForm from "../ActionQualityCheck/PushBackForm";
import config from "../../../../../../common/repository/config";
import LocalStorage from "../../../../../../lib/LocalStorage";
import CaseTypeNew from "../../../../../../models/CaseTypeNew";
import { RouteComponentProps } from "react-router-dom";
interface Props extends RouteComponentProps {
  model: CompleteCase;
  loggedUserTitle: string;
  updateModel(model: CompleteCase): void;
  CaseServiceData: CaseServiceData;
}

interface State {
  loading: boolean;
  loadingAllocatedInvestigators: boolean;
  loadingCaseTypes: boolean;
  caseTypes: CaseType[];
  allocatedInvestigators: AllocatedInvestigator[];
  caseOutcome: string;
  caseType: any | string;
  caseTypeModel: CaseType | CaseTypeNew;
  report: File | null;
  Query_Trigger_Document: File | null;
  repudiation_Ground: string;
  repudiationEvidence: File[];
  loadibgCaseServiceData: boolean;
  pushbackModalOpen: boolean;
  pushback: string;
  caseService: CaseService[];
  caseServiceData: CaseServiceData[];
  AttendentInfoData: AttendentInfoData[];
  doctorPathologistsData: DoctorPathologistsData[];
  hospitalInfrastructureData: HospitalInfrastructureData[];
  InsuredInfoData: InsuredInfoData[];
  treatingDoctorsData: TreatingDoctorsData[];
  form_investigators: AllocatedInvestigator[];
  case_overallOutcome: string;
  case_investigationData: (InvestigatorCaseOutcomeInputValue | null)[];
  isInvestigatorsOutcomeRepudiation: boolean;
  evidenceSizeExceedsMessage: string;
  evidenceSizeExceedsPopupVisible: boolean;
  repudiationGroundList: RepudiationGround[];
  changePopUp: any;
  confirmation: any;
  selectedCaseType: any;
  getReport: boolean;
  closeCaseTypeModel: any;
  newCaseCategoryCode: any;
  repudiationEvidencePopupOpen: boolean;
  downloading: boolean;
  showLoader: boolean;
  generateReportModalOpen: boolean;
  treatmentTypeSurgical: boolean;
  treatmentTypeConservative: boolean;
  diagnosisAcuteChecked: boolean;
  diagnosisChronicChecked: boolean;
  diagnosisList: any[];
  reportGenerationStatus: string;
  generationStatusLoading: boolean
  loadingDiagnosis: boolean;
  selectedAcuteDiagnosis: string;
  selectedChronicDiagnosis: string;
  selectedAcuteDiagnosisObj: any | null;
  selectedChronicDiagnosisObj: any | null;
}

interface EvidenceItem {
  getURL: () => string;
}

interface Props {
  caseId: string;
  evidence: EvidenceItem[];
}



class ActionFold extends React.Component<Props, State> {
  private caseRepo = new CaseRepository();
  private caseTypeRepo = new CaseTypeRepository();
  private RepudiationGroundRepository = new RepudiationGroundRepository();
  private clientRepo = new ClientRepository();
  private portalRoot: HTMLElement | null = null;
  
  constructor(props: Props) {
    super(props);
    this.state = {
      loading: false,
      loadingAllocatedInvestigators: true,
      loadingCaseTypes: true,
      downloading: false,
      showLoader: false,
      caseTypes: [],
      allocatedInvestigators: [],
      caseOutcome: "",
      caseType: props.model.getType()?.getId() || "",
      caseTypeModel: props.model.getType(),
      report: null,
      Query_Trigger_Document: null,
      repudiation_Ground: "",
      repudiationEvidence: [],
      form_investigators: [],
      case_overallOutcome: "",
      case_investigationData: [],
      pushbackModalOpen: false,
      pushback: "",
      reportGenerationStatus: "",
      generationStatusLoading: false,
      isInvestigatorsOutcomeRepudiation: false,
      evidenceSizeExceedsMessage: "",
      evidenceSizeExceedsPopupVisible: false,
      loadibgCaseServiceData: true,
      caseService: [],
      getReport: false,
      caseServiceData: [],
      AttendentInfoData: [],
      doctorPathologistsData: [],
      hospitalInfrastructureData: [],
      InsuredInfoData: [],
      treatingDoctorsData: [],
      repudiationGroundList: [],
      changePopUp: false,
      confirmation: false,
      selectedCaseType: "",
      closeCaseTypeModel: false,
      newCaseCategoryCode: props.model.getCategory().getCode(),
      repudiationEvidencePopupOpen: false,
      generateReportModalOpen: false,
      treatmentTypeSurgical: false,
      treatmentTypeConservative: false,
      diagnosisAcuteChecked: false,
      diagnosisChronicChecked: false,
      diagnosisList: [],
      loadingDiagnosis: false,
      selectedAcuteDiagnosis: "",
      selectedChronicDiagnosis: "",
      selectedAcuteDiagnosisObj: null,
      selectedChronicDiagnosisObj: null,
    };
    // { console.log(this.state.caseTypeModel.getTitle(), "this.state.selectedCaseType") }
  
  }

  componentDidMount() {
    this.getAllocatedInvestigators();
    this.getCaseTypes();
    this.getServices();

    this.getAttendentInfoData();
    this.getDoctorPathologistsData();
    this.getHospitalInfrastructureData();
    this.getInsuredInfoData();
    this.getTreatingDoctorsData();
    this.getRepudiationGround();
    this.getReportGenerationStatus();
    this.portalRoot = document.getElementsByTagName("body")[0];

  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.model != this.props.model) {
      this.getAllocatedInvestigators();
    }

    if (
      prevProps.model.getType().getId() !== this.props.model.getType().getId()
    )
      this.setState({
        caseType: this.props.model.getType().getId(),
        caseTypeModel: this.props.model.getType(),
      });

    // console.log(this.state.caseTypeModel, "caseTypeModel")

    // for(let i=0; i< this.state.form_investigators.length; i++){
    //     let it = this.state.form_investigators[i];
    //     if(it.getOutcome() !=null && !this.state.isInvestigatorsOutcomeRepudiation){
    //         if(it.getOutcome() == constants.caseOutcome.repudiation) this.setState({isInvestigatorsOutcomeRepudiation: true});
    //         break;
    //     }
    // }
    // if(this.state.isInvestigatorsOutcomeRepudiation) this.setState({caseOutcome: constants.caseOutcome.repudiation})
  }

  private getReportGenerationStatus = async () => {
    const { model } = this.props;
    this.setState({ generationStatusLoading: true});
  
    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) {
        console.error("Authentication token is missing.");
        return;
      }

     
      const requestBody: any = {
        caseId: model.getId(),
      };
  
      const response = await fetch(`${config.apiBaseURL}/case/getReport/status`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(requestBody),
      });

      let responseData = await response.json();
  
      if (!response.ok) {
        if(response.status !== 404) {
          toast.error(responseData.message || "Something went wrong");
        }
         
        return;     
      }
      this.setState({reportGenerationStatus: responseData.data.items.status})
    } catch (e) {
      toast.error(e as string);
    } finally {
      this.setState({generationStatusLoading: false});
    }

  }

  private getRepudiationGround = () => {
    this.setState({ loadingCaseTypes: true }, async () => {
      const result =
        await this.RepudiationGroundRepository.getRepuditationGround();
      if (result instanceof Result.Success) {
        const repudiationGroundList = result.data.items;
        this.setState({ repudiationGroundList, loadingCaseTypes: false });
      } else {
        this.setState({ loadingCaseTypes: false }, () => {
          const message = result.message || "Could not load Case Types";
          toast.error(message);
        });
      }
    });
  };

  public getAllocatedInvestigators = async () => {
    this.setState({ loadingAllocatedInvestigators: true }, async () => {
      const { model } = this.props;
      const result = await this.caseRepo.getAllocatedInvestigators({
        case_id: model.getId(),
      });
      if (result instanceof Result.Success) {
        const investigators = result.data.items;
        console.log(investigators,"invap");
        const investigationData = new Array(investigators.length).fill(null);
        await this.setState({
          loadingAllocatedInvestigators: false,
          form_investigators: investigators,
          case_investigationData: investigationData,
        });
      } else {
        this.setState({ loadingAllocatedInvestigators: false }, () => {
          const message =
            result.message || "Could not load Allocated Investigators";
          toast.error(message);
        });
      }
    });
  };

  private getCaseTypes = () => {
    this.setState({ loadingCaseTypes: true }, async () => {
      const model = this.props.model;
      let clientId: string | null = null;
      
      if (model.getTPA() !== null) {
        clientId = model.getTPA()!.getId();
      } else if (model.getInsuranceCompany() !== null) {
        clientId = model.getInsuranceCompany()!.getId();
      }
      
      if (clientId && clientId.trim().length > 0) {
        const clientResult = await this.clientRepo.getClients({ id: clientId });
        if (clientResult instanceof Result.Success && clientResult.data.items.length > 0) {
          const client = clientResult.data.items[0];
          const clientCaseTypes = client.getCaseTypes();
      
          // Filter only active case types
          const activeCaseTypes = clientCaseTypes.filter((ct) => ct.getActive());
              console.log(activeCaseTypes,"q22222")
          if (activeCaseTypes.length > 0) {
            this.setState({ caseTypes: activeCaseTypes, loadingCaseTypes: false });
            return;
          }
        }
      }
      
      const result = await this.caseTypeRepo.getCaseTypes();
      console.log(result,"result@@@@")
      if (result instanceof Result.Success) {
        const caseTypes = result.data.items;
        this.setState({ caseTypes, loadingCaseTypes: false });
      } else {
        this.setState({ loadingCaseTypes: false }, () => {
          const message = result.message || "Could not load Case Types";
          toast.error(message);
        });
      }
    });
  };

  private updateAllocatedInvestigator = (model: AllocatedInvestigator) => {
    const investigators = this.state.form_investigators;
    const index = investigators.findIndex((it) => it.getId() === model.getId());
    if (index === -1) return;

    investigators[index] = model;
    this.setState({ form_investigators: [...investigators] });
  };

  private removeAllocatedInvestigator = (model: AllocatedInvestigator) => {
    const investigators = this.state.form_investigators;
    const index = investigators.findIndex((it) => it.getId() === model.getId());
    if (index === -1) return;

    investigators.splice(index, 1);
    this.setState({ form_investigators: [...investigators] });
  };

  private getServices = () => {
    this.setState({ loadibgCaseServiceData: true }, async () => {
      const result = await this.caseRepo.getCaseServices(
        this.props.model.getId()
      );
      console.log(result, "kalyani")
      if (result instanceof Result.Success) {
        const caseService = result.data.items;
        this.setState({ caseService, loadibgCaseServiceData: false });
      } else {
        this.setState({ loadibgCaseServiceData: false }, () => {
          const message = result.message || "Could not load Services";
          toast.error(message);
        });
      }
    });
  };

  private getAttendentInfoData = () => {
    this.setState({ loadibgCaseServiceData: true }, async () => {
      const result = await this.caseRepo.getAttendentInfoData(
        this.props.model.getId()
      );
      if (result instanceof Result.Success) {
        const AttendentInfoData = result.data.items;
        this.setState({ AttendentInfoData, loadibgCaseServiceData: false });
      } else {
        this.setState({ loadibgCaseServiceData: false }, () => {
          const message = result.message || "Could not AttendentInfo Data";
          toast.error(message);
        });
      }
    });
  };

  private getDoctorPathologistsData = () => {
    this.setState({ loadibgCaseServiceData: true }, async () => {
      const result = await this.caseRepo.getDoctorPathologistsData(
        this.props.model.getId()
      );
      if (result instanceof Result.Success) {
        const doctorPathologistsData = result.data.items;
        this.setState({
          doctorPathologistsData,
          loadibgCaseServiceData: false,
        });
      } else {
        this.setState({ loadibgCaseServiceData: false }, () => {
          const message = result.message || "Could not AttendentInfo Data";
          toast.error(message);
        });
      }
    });
  };

  private getHospitalInfrastructureData = () => {
    this.setState({ loadibgCaseServiceData: true }, async () => {
      const result = await this.caseRepo.getHospitalInfrastructureData(
        this.props.model.getId()
      );
      if (result instanceof Result.Success) {
        const hospitalInfrastructureData = result.data.items;
        this.setState({
          hospitalInfrastructureData,
          loadibgCaseServiceData: false,
        });
      } else {
        this.setState({ loadibgCaseServiceData: false }, () => {
          const message = result.message || "Could not AttendentInfo Data";
          toast.error(message);
        });
      }
    });
  };

  private getInsuredInfoData = () => {
    this.setState({ loadibgCaseServiceData: true }, async () => {
      const result = await this.caseRepo.getInsuredInfoData(
        this.props.model.getId()
      );
      if (result instanceof Result.Success) {
        const InsuredInfoData = result.data.items;
        this.setState({ InsuredInfoData, loadibgCaseServiceData: false });
      } else {
        this.setState({ loadibgCaseServiceData: false }, () => {
          const message = result.message || "Could not AttendentInfo Data";
          toast.error(message);
        });
      }
    });
  };

  private getTreatingDoctorsData = () => {
    this.setState({ loadibgCaseServiceData: true }, async () => {
      const result = await this.caseRepo.getTreatingDoctorsData(
        this.props.model.getId()
      );
      if (result instanceof Result.Success) {
        const treatingDoctorsData = result.data.items;
        this.setState({ treatingDoctorsData, loadibgCaseServiceData: false });
      } else {
        this.setState({ loadibgCaseServiceData: false }, () => {
          const message = result.message || "Could not AttendentInfo Data";
          toast.error(message);
        });
      }
    });
  };

  // private getServicesData = () => {
  //   this.setState({ loadibgCaseServiceData: true }, async () => {
  //     const result = await this.caseRepo.getCaseServicesData(this.props.model.getId());
  //     // console.log(result, "result2")
  //     if (result instanceof Result.Success) {
  //       const caseServiceData: any = result.data.items[0]['AttendentInfoData'];
  //       // const AttendentInfoData:any = result.data.items[0]['H'];
  //       // const AttendentInfoData:any = result.data.items[0]['AttendentInfoData'];
  //       // const AttendentInfoData:any = result.data.items[0]['AttendentInfoData'];
  //       // const AttendentInfoData:any = result.data.items[0]['AttendentInfoData'];
  //       // console.log(" test", caseServiceData.AttendentInfoData)
  //       this.setState({ caseServiceData, loadibgCaseServiceData: false });
  //     } else {
  //       this.setState({ loadibgCaseServiceData: false }, () => {
  //         const message = result.message || "Could not load Services Data ";
  //         toast.error(message);
  //       });
  //     }
  //   });
  // };

  private enableReinvestigation = (model: AllocatedInvestigator) => {
    this.setState({ loadingAllocatedInvestigators: true }, async () => {
      const result = await this.caseRepo.enableReInvestigation(model.getId());
      if (result instanceof Result.Success) {
        const investigators = result.data.items;
        const investigationData = new Array(investigators.length).fill(null);
        this.setState({
          loadingAllocatedInvestigators: false,
          form_investigators: investigators,
          case_investigationData: investigationData,
        });
      } else {
        this.setState({ loadingAllocatedInvestigators: false }, () => {
          const message =
            result.message || "Could not load Allocated Investigators";
          toast.error(message);
        });
      }
    });
  };

  private formatBytes = (a: number, b = 2) => {
    if (0 === a) return "0 Bytes";
    const c = 0 > b ? 0 : b,
      d = Math.floor(Math.log(a) / Math.log(1024));
    return (
      parseFloat((a / Math.pow(1024, d)).toFixed(c)) +
      " " +
      ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d]
    );
  };

  private fetchDiagnosisList = async () => {
    this.setState({ loadingDiagnosis: true });
    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) {
        toast.error("Authentication token is missing.");
        this.setState({ loadingDiagnosis: false });
        return;
      }

      const res = await fetch(`${config.apiBaseURL}/diagnosis/list`, {
        method: "POST",
        headers: { "x-access-token": token },
      });

      const data = await res.json();
      const diagnosisList = Array.isArray(data?.data?.items) ? data.data.items : [];
      this.setState({ diagnosisList, loadingDiagnosis: false });
    } catch (error) {
      toast.error("Failed to load diagnosis list");
      this.setState({ diagnosisList: [], loadingDiagnosis: false });
    }
  };

  private openGenerateReportModal = () => {
    this.setState({ generateReportModalOpen: true });
    this.fetchDiagnosisList();
  };

  private closeGenerateReportModal = () => {
    this.setState({
      generateReportModalOpen: false,
      treatmentTypeSurgical: false,
      treatmentTypeConservative: false,
      diagnosisAcuteChecked: false,
      diagnosisChronicChecked: false,
      selectedAcuteDiagnosis: "",
      selectedChronicDiagnosis: "",
      selectedAcuteDiagnosisObj: null,
      selectedChronicDiagnosisObj: null,
    });
  };

  private isGenerateButtonDisabled = (): boolean => {
    // At least one treatment type must be selected
    const hasTreatmentType = this.state.treatmentTypeSurgical || this.state.treatmentTypeConservative;
    
    // At least one diagnosis must be selected
    const hasDiagnosis = 
      (this.state.diagnosisAcuteChecked && this.state.selectedAcuteDiagnosis) ||
      (this.state.diagnosisChronicChecked && this.state.selectedChronicDiagnosis);
    
    return !hasTreatmentType || !hasDiagnosis;
  };

  handleReportDownload = async ()  => {
    console.log("download hit");
    const { model } = this.props;
    this.setState({ downloading: true, showLoader: true });
    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) {
        return;
      }

      const requestBody: any = {
        caseId: model.getId(),
      };

      const response = await fetch(`${config.apiBaseURL}/case/generatedReportDownload`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(requestBody),
      });
      
      if (!response.ok) {
        let responseData = await response.json();
        toast.error(responseData.message || "Something went wrong");
        return;
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      const disposition = response.headers.get("Content-Disposition");

      let fileName = `Report ${model.getClaimNumber()}`;
      if (disposition && disposition.indexOf("attachment") !== -1) {
        const parts = disposition.split(";");
        for (let part of parts) {
          part = part.trim();
          if (part.startsWith("filename=")) {
            fileName = part.substring(9).replace(/['"]/g, "");
          }
        }
      }
  
      a.download = `${fileName}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
  
      toast.success("Report downloaded successfully.");


    } catch (e) {
      toast.error(e as string);
    } finally {
      this.setState({ downloading: false, showLoader: false });
    }
  }

  handleReportGenerate = async (caseId: any) => {
    const { model } = this.props;
    this.setState({getReport: true});
  
    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) {
        return;
      }

     
      const requestBody: any = {
        caseId: model.getId(),
      };

      if (this.state.treatmentTypeSurgical) {
        requestBody.treatmentType = constants.treatmentType.surgical;
      } else if (this.state.treatmentTypeConservative) {
        requestBody.treatmentType = constants.treatmentType.conservative;
      }

      let globalRule = "";
      if (this.state.diagnosisAcuteChecked && this.state.selectedAcuteDiagnosis && this.state.selectedAcuteDiagnosisObj) {
        globalRule = this.state.selectedAcuteDiagnosisObj.global_rule || 
                    this.state.selectedAcuteDiagnosisObj.globalRule || 
                    "";
      } else if (this.state.diagnosisChronicChecked && this.state.selectedChronicDiagnosis && this.state.selectedChronicDiagnosisObj) {
        globalRule = this.state.selectedChronicDiagnosisObj.global_rule || 
                    this.state.selectedChronicDiagnosisObj.globalRule || 
                    "";
      }
      
      requestBody.globalRule = globalRule;
      
  
      const response = await fetch(`${config.apiBaseURL}/case/generate-report/start`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(requestBody),
      });
  
      if (!response.ok) {  
        toast.error(response.statusText);      
      }
      let data  = await response.json();
      toast.success(data.message);

      this.closeGenerateReportModal();
    } catch (error) {
      let message = "Something went wrong while generating the report";
      if (error instanceof Error) {
        message = error.message;
      }
      toast.error(message);
    } finally {
      // this.setState({ downloading: false, showLoader: false });
      this.setState({getReport: false});
    }
  };
  
  private getInsuredInfo = async() => {
    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) return null;
      let response = await fetch(`${config.apiBaseURL}/cases/getInsuredInfo`,  {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token || ""
        },
        body: JSON.stringify({
          userId: "",
          hospitalId: "",
          caseId: ""
        })
      });

      const data = await response.json();
      toast.success(data.message);
      




    } catch(e) {
      toast.error(e as string);
    }
  }
  
  private onSubmit = () => {
    this.setState({ loading: true }, async () => {
      const { model, updateModel } = this.props;
      console.log(model,"sdjj")
      let flag = true;
      if (
        !(
          this.props.loggedUserTitle === constants.roleTitle.ceo ||
          this.props.loggedUserTitle === constants.roleTitle.md ||
          this.props.loggedUserTitle === constants.roleTitle.admin
        )
      ) {
        const evidenceSizeResult = await this.caseRepo.getEvidenceSize(
          model.getClaimNumber()
        );
        if (evidenceSizeResult instanceof Result.Success) {
          const c = evidenceSizeResult.data[0] as {
            aws_evidence_size: number;
            saved_evidence_size: number;
          };

          if (c.aws_evidence_size > c.saved_evidence_size) {
            let diff = this.formatBytes(
              c.aws_evidence_size - c.saved_evidence_size
            );

            this.setState({
              loading: false,
              evidenceSizeExceedsPopupVisible: true,
              evidenceSizeExceedsMessage: `Evidence size is ${diff} more than the limit`,
            });

            flag = false;
          }
        } else {
          this.setState({ loading: false }, () => {
            const message =
              evidenceSizeResult.message || "Something went wrong";
            toast.error(message);
          });
        }
      }

      if (flag) {
        let result: any
        if (this.state.caseOutcome == constants.caseOutcome.repudiation) {
          result = await this.caseRepo.foldCase({
            case_id: model.getId(),
            outcome: this.state.caseOutcome,
           case_type: this.state.caseType,
            //case_category: this.state.caseTypeModel.getCaseCategoryCode(),
            case_category: this.state.newCaseCategoryCode,
            outcome_report: this.state.report!,
            repudiation_ground: this.state.repudiation_Ground,
            // query_trigger_document: this.state.Query_Trigger_Document!,
            repudiation_evidences: this.state.repudiationEvidence,
          });
        }
        if (this.state.caseOutcome == constants.caseOutcome.inconclusive) {
          result = await this.caseRepo.foldCase({
            case_id: model.getId(),
            outcome: this.state.caseOutcome,
          case_type: this.state.caseType,
            //case_category: this.state.caseTypeModel.getCaseCategoryCode(),
            case_category: this.state.newCaseCategoryCode,
            outcome_report: this.state.report!,
            // repudiation_ground: this.state.repudiation_Ground,
            query_trigger_document: this.state.Query_Trigger_Document!,
            // repudiation_evidences: this.state.repudiationEvidence,
          });
        }
        if (this.state.caseOutcome == constants.caseOutcome.genuine) {
        console.log( this.state.selectedCaseType,"jkjkjkjkjkj")
          result = await this.caseRepo.foldCase({
            case_id: model.getId(),
            outcome: this.state.caseOutcome,
           case_type: this.state.caseType,
            //case_category: this.state.caseTypeModel.getCaseCategoryCode(),
            case_category: this.state.newCaseCategoryCode,
            outcome_report: this.state.report!,
            // repudiation_ground: this.state.repudiation_Ground,
            // query_trigger_document: this.state.Query_Trigger_Document!,
            // repudiation_evidences: this.state.repudiationEvidence,
          });
        }
        if (result instanceof Result.Success) {
          this.setState({ loading: false }, () => {
            const c = result.data as CompleteCase;
            toast.success("Successfully closed Case");
            updateModel(c);
          });
        } else {
          this.setState({ loading: false }, () => {
            const caseId = this.props.model.getId();
            if (result.message === "Please Fill Dob of the Insured First") {
              if (caseId) {
                window.location.href = `/case/edit/${caseId}`;
              }
              return;
            }
            const message = result.message || "Something went wrong";
            toast.error(message);
          });
        }
      }
    });
  };

  render() {
    const { model, updateModel } = this.props;

       let report: any = null;

      if (this.props.model.getReport() !== null) report = this.props.model.getReport();
      let reInvestigationReport: any = null;
      if (report !== null) reInvestigationReport = report[report.length - 1];

      let investigationReports: any = null;
      // if (investigationReports !== null) investigationReports = report[]
    
    // let report = this.props.model.getReport();
    let filalReports = this.props.model.getFinalReport();
    let repudiationEvidence: any[] = [];
    let queryTriggerDocument = null;

    if (this.props.model.getReinvestigation()) {
      console.log(model.getQueryTriggerDocument())
      if (model.getRepudiationEvidence())
        repudiationEvidence = this.props.model.getRepudiationEvidence();

      if (this.props.model.getQueryTriggerDocument() !== null) queryTriggerDocument = this.props.model.getQueryTriggerDocument();
    }



    let ServiceTab = [
      {
        menuItem: "HOSPITAL INFRASTRUCTURE INFORMATION",
        render: () => (
          <Tab.Pane attached={false}>
            <HospitalInfrastructureDataTable
              data={this.state.hospitalInfrastructureData}
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: "TREATING DOCTOR INFORMATION",
        render: () => (
          <Tab.Pane attached={false}>
            <TreatingDoctorsDataTable data={this.state.treatingDoctorsData} />
          </Tab.Pane>
        ),
      },
      {
        menuItem: "PATHOLOGIST INFORMATION",
        render: () => (
          <Tab.Pane attached={false}>
            <DoctorPathologistsDataTable
              data={this.state.doctorPathologistsData}
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: "INSURED INFORMATION",
        render: () => (
          <Tab.Pane attached={false}>
            <InsuredInfoDataTable data={this.state.InsuredInfoData} />
          </Tab.Pane>
        ),
      },
      {
        menuItem: "ATTENDANT INFORMATION",
        render: () => (
          <Tab.Pane attached={false}>
            <AttendentInfoDataTable data={this.state.AttendentInfoData} />
          </Tab.Pane>
        ),
      },
    ];

    let caseServiceData = this.state.caseService
      .map((it) => it.getServiceData())
      .splice(0, ServiceTab.length);
    let newArr: any = [];

    ServiceTab.forEach((item) => {
      caseServiceData.forEach((value) => {
        if (item.menuItem == value) newArr.push(item);
      });
    });
    const CaseServiceTab = () => (
      <Tab menu={{ pointing: true }} panes={newArr} />
    );

    const RepudiationGround = this.state.repudiationGroundList.map((it) => {
      return {
        text: it.getRepudiationGround(),
        value: it.getId(),
        key: it.getId(),
      };
    });

    let allocatedInvestigators: React.ReactNode | null = null;
    if (this.state.loadingAllocatedInvestigators)
      allocatedInvestigators = <InvestigatorsLoadingState />;
    else {
      allocatedInvestigators = this.state.form_investigators.map((it, index) => {
        if (index === 0) {
          return (
            <InvestigatorCard
              case_portion = {model.getType().getInitialCasePortionCapping()}
              approved_expense={model.getApproved_expense()}
              approved_expense_receipt={model.getApproved_expense_receipt()}
              model={it}
              case_id={this.props.model.getId()}
              updateModel={this.updateAllocatedInvestigator}
              removeModel={this.removeAllocatedInvestigator}
              enableReinvestigation={this.enableReinvestigation}
            />
          );
        } else {
          return (
            <InvestigatorCard
              case_portion = {model.getType().getInitialCasePortionCapping()}
              model={it}
              case_id={this.props.model.getId()}
              updateModel={this.updateAllocatedInvestigator}
              removeModel={this.removeAllocatedInvestigator}
              enableReinvestigation={this.enableReinvestigation}
            />
          );
        }

      });
    }

    return (
      <Segment loading={this.state.loading} basic>
        <TransitionablePortal open={this.state.evidenceSizeExceedsPopupVisible}>
          <Segment
            style={{
              left: "40%",
              position: "fixed",
              top: "50%",
              zIndex: 1000,
              backgroundColor: "#f08080",
              color: "#fff",
            }}
          >
            <Header style={{ color: "#fff" }}>Evidence Size Exceeds</Header>
            <p>{this.state.evidenceSizeExceedsMessage}</p>
            <p>Please delete some Evidences or Contact MD/CEO</p>
          </Segment>
        </TransitionablePortal>

        {this.props.model.getReinvestigation() && <div>
          <Header as="h3">
            Re-investigation Reports
          </Header>
          {/* report */}
          <Button
            as="a"
            href={reInvestigationReport ? reInvestigationReport.getURL() : undefined}
            disabled={!reInvestigationReport}
            target="_blank"
            icon
            primary
            labelPosition="left"
            size="tiny"
          >
            <Icon name="file alternate outline" />
            View Report
          </Button>
          {/* report */}

          {/* repudiation evidence */}
          {model.getOutcome() == "Repudiation" && <Button
            icon
            primary
            labelPosition="left"
            size="tiny"
            disabled={
              this.state.repudiationEvidencePopupOpen ||
              repudiationEvidence.length === 0
            }
            onClick={() =>
              this.setState({ repudiationEvidencePopupOpen: true })
            }
          >
            <Icon name="file alternate outline" />
            {repudiationEvidence.length === 0
              ? "No Repudiation Evidence"
              : "View Repudiation Evidence"}
          </Button>}
          {/* repudiation evidence */}
          <Label basic size={"large"} color={"blue"}>
            Case Type{" "}
            <Label.Detail>{model.getType().getTitle()}</Label.Detail>
          </Label>
          <Label basic size={"large"} color={"blue"}>
            Case Outcome <Label.Detail>{model.getOutcome()}</Label.Detail>
          </Label>
          {model.getRepudiationGround() && model.getOutcome() == "Repudiation" && <Label basic size={"large"} color={"blue"}>
            Repudation Ground <Label.Detail>{model.getRepudiationGround()}</Label.Detail>
          </Label>}
          {/* Final Report */}
          {filalReports !== null && (
            <Button
              as="a"
              href={filalReports.getURL()}
              disabled={false}
              target="_blank"
              icon
              primary
              labelPosition="left"
              size="tiny"
            >
              <Icon name="file alternate outline" />
              Final Report
            </Button>
          )}
          {/* Repudiation Evidence */}
          {this.state.repudiationEvidencePopupOpen &&
            ReactDOM.createPortal(
              <FilesPopup
                title="Repudiation Evidence"
                onClose={() => this.setState({ repudiationEvidencePopupOpen: false })}
                files={repudiationEvidence} allocationId={model.getId()} />,
              this.portalRoot!
            )}

          {/* Query trigger Document */}
          {queryTriggerDocument !== null && model.getOutcome() == "Inconclusive" && (
            <Button
              as="a"
              href={queryTriggerDocument.getURL()}
              disabled={false}
              target="_blank"
              icon
              primary
              labelPosition="left"
              size="tiny"
            >
              <Icon name="file alternate outline" />
              Query Trigger Document
            </Button>
          )}
        </div>
        }
        <Header as="h3">
          Initial Closure
          <Header.Subheader>
            These fields needs to be filled by the Claim Analyst. Upon
            submitting case will be Quality Checked by the Operation Head and
            CEO/MD.
          </Header.Subheader>
        </Header>

        <Message info>
          NOTE: If 2 or more Claim Analysts are working on the case then case
          will only be eligible for Quality Check when all of them has submitted
          for the same.
        </Message>

        {allocatedInvestigators}
        {/* <Segment> */}

        <Header as="h3">Reports</Header>
        {this.state?.caseService && <CaseServiceTab />}
        {/* </Segment> */}
        {
          (this.props.model.getState() === constants.caseStates.report ||
         this.props.model.getState() === constants.caseStates.pushbackRW) &&
          <div
            style={{ display: "flex", justifyContent: "right", margin: "15px 0px 15px 0px" }}
          >
            <Modal
              open={this.state.pushbackModalOpen}
              onClose={() => this.setState({ pushbackModalOpen: false })}
              size="tiny"
              closeOnDimmerClick={false}
              closeOnEscape={false}
              closeIcon
              trigger={
                <RequirePermission permission={permissions.Case.pushback}>
                  <Button
                    icon
                    negative
                    labelPosition="left"
                    onClick={() => this.setState({ pushbackModalOpen: true, pushback: "pushback" })}
                  >
                    <Icon name="ban" />
                    Push Back
                  </Button>
                </RequirePermission>
              }
            >
              <Modal.Header>Push Back</Modal.Header>
              <Modal.Content>
                <PushBackForm
                  model={this.props.model}
                  onSuccess={(it) => {
                    this.setState({ pushbackModalOpen: false });
                    if (updateModel) updateModel(it as CompleteCase);
                  }}
                  pushback={this.state.pushback}
                />
              </Modal.Content>
            </Modal>
          </div>
        }
        <>

          {this.state.showLoader && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <Loader active inline="centered" size="huge" />
            </div>
          )}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              padding: "10px 0",
            }}
          >
            <Button
              onClick={this.openGenerateReportModal}
              disabled={
                this.state.form_investigators.findIndex((it) => it.getActive()) !== -1 ||
                this.state.generationStatusLoading ||
                this.state.reportGenerationStatus === "processing" ||
                this.state.reportGenerationStatus === "completed" 
              }
              style={{
                marginLeft: "10px",
                padding: "12px 24px",
                backgroundColor: "#2185d0",
                color: "#FFFFFF",
                fontSize: "16px",
                fontWeight: "600",
                borderRadius: "6px",
                minWidth: "150px",
                border: "none",
              }}
            >
              {this.state.reportGenerationStatus === "processing"
                ? "Generating..."
                : this.state.reportGenerationStatus === "failed"
                ? "Retry Report"
                : "Generate Report"}
            </Button>
            {this.state.reportGenerationStatus !== "" ? 
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "16px",
                  fontWeight: "bold"
                }}
              >
                <span>Report Generation Status:</span>

                {this.state.reportGenerationStatus === "processing" && (
                  <span
                    style={{
                      padding: "6px 14px",
                      borderRadius: "20px",
                      backgroundColor: "#fff3cd",
                      color: "#856404",
              
                    }}
                  >
                    ⏳ Processing
                  </span>
                )}

                {this.state.reportGenerationStatus === "completed" && (
                  <span
                    style={{
                      padding: "6px 14px",
                      borderRadius: "20px",
                      backgroundColor: "#d4edda",
                      color: "#155724",
                
                    }}
                  >
                    ✓ Completed
                  </span>
                )}

                {this.state.reportGenerationStatus === "failed" && (
                  <span
                    style={{
                      padding: "6px 14px",
                      borderRadius: "20px",
                      backgroundColor: "#f8d7da",
                      color: "#721c24",
                    }}
                  >
                    ✕ Failed
                  </span>
                )}
              </div>
              :
              <span></span>
            } 

            <Button
              onClick={this.handleReportDownload}
              disabled={
                this.state.generationStatusLoading ||
                this.state.reportGenerationStatus !== "completed"
              }
              style={{
                marginRight: "10px",
                padding: "12px 24px",
                backgroundColor:
                  this.state.reportGenerationStatus === "completed"
                    ? "#2185d0"
                    : "#bdbdbd",
                color: "#FFFFFF",
                fontSize: "16px",
                fontWeight: "600",
                borderRadius: "6px",
                minWidth: "150px",
                border: "none",
                cursor:
                  this.state.reportGenerationStatus === "completed"
                    ? "pointer"
                    : "not-allowed",
              }}
            >
              Download Report
            </Button>
          </div>

          {/* <div style={{display:"flex", justifyContent:"space-between"}}>
            <Button
              onClick={this.openGenerateReportModal}
              disabled={
                this.state.form_investigators.findIndex((it) => it.getActive()) !== -1 ||
                this.state.generationStatusLoading || this.state.reportGenerationStatus === "completed" || this.state.reportGenerationStatus === "processing"
              }
              style={{
                marginLeft: "10px",
                marginTop: "10px",
                padding: "12px 24px",
                backgroundColor: "#2185d0",
                color: "#FFFFFF",
                fontSize: "16px",
                borderRadius: "6px",
                minWidth: "150px"
              }}
            >
              Generate Report
            </Button>
            <div>
              Report Generation Status: {this.state.reportGenerationStatus}
            </div>
            <Button
              onClick={this.openGenerateReportModal}
              disabled={
                this.state.form_investigators.findIndex((it) => it.getActive()) !== -1 ||
                this.state.generationStatusLoading || this.state.reportGenerationStatus === "completed" || this.state.reportGenerationStatus === "processing"
              }
              style={{
                marginLeft: "10px",
                marginTop: "10px",
                padding: "12px 24px",
                backgroundColor: "#2185d0",
                color: "#FFFFFF",
                fontSize: "16px",
                borderRadius: "6px",
                minWidth: "150px"
              }}
            >
              Download Report
            </Button>
          </div> */}
        </>
        <Segment>
          <Form>
            <Grid columns={3} verticalAlign="bottom">
              <Grid.Row>
                <Grid.Column>
                  <Form.Dropdown
                    label="Case Outcome"
                    search
                    selection
                    placeholder="Outcome"
                    options={this.toOutcomeOptions(
                      Object.values(constants.caseOutcome)
                    )}
                    value={this.state.caseOutcome}
                    onChange={(_, { value }) =>
                      this.setState({ caseOutcome: value as string })
                    }
                  />
                </Grid.Column>

                <Grid.Column>
                  <Form.Dropdown
                    label="Case Type"
                    search
                    selection
                    placeholder="Case Type"
                    loading={this.state.loadingCaseTypes}
                    value={this.state.caseType}
                    options={this.toCaseTypeOptions(this.state.caseTypes)}
                    onChange={(_, { value }) => {
                      // Get the case type and update category code immediately
                      const caseType = this.getCaseTypeById(value as string);
                  
                      if (caseType === null) return;
                      
                      const caseCategoryCode = caseType.getCaseCategoryCode();
                      
                      if (
                        value !== this.props.model.getType().getId().toString()
                      ) {
                        this.setState((prev) => {
                          return {
                            changePopUp: !prev.changePopUp,
                            selectedCaseType: value,
                            caseTypeModel: caseType,                            
                            newCaseCategoryCode: caseCategoryCode || prev.newCaseCategoryCode,
                          };
                        });
                      } else {
                        this.setState((prev) => {
                          return {
                            selectedCaseType: value,
                            caseType: value,
                            caseTypeModel: caseType,
                            newCaseCategoryCode: caseCategoryCode || prev.newCaseCategoryCode,
                          };
                        });
                      }
                      if (this.state.confirmation == true) {
                        this.setState({
                          caseType: value as string,
                          caseTypeModel: caseType,
                          newCaseCategoryCode: caseCategoryCode || this.state.newCaseCategoryCode,
                        });
                      }
                    }}
                  // onClick={() => this.setState({ changePopUp: true })}
                  />
                </Grid.Column>

                <Grid.Column>
                  <Form.Dropdown
                    label="Repudiation Ground"
                    search
                    selection
                    placeholder="Repudiation Ground"
                    value={this.state.repudiation_Ground}
                    options={RepudiationGround}
                    onChange={(_, { value }) =>
                      this.setState({ repudiation_Ground: value as string })
                    }
                    disabled={
                      this.state.caseOutcome !==
                      constants.caseOutcome.repudiation
                    }
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column>
                  <Form.Input
                    label="Report"
                    type="file"
                    accept="image/*, .pdf, .doc, .docx, .csv, .xls, .xlsx"
                    onChange={(e) => {
                      const files = e.target.files;
                      if (files === null) this.setState({ report: null });
                      else this.setState({ report: files[0] });
                    }}
                  />
                </Grid.Column>

                <Grid.Column>
                  <Form.Input
                    label="Query Trigger Document"
                    type="file"
                    accept="image/*, .pdf, .doc, .docx, .csv, .xls, .xlsx"
                    onChange={(e) => {
                      const files = e.target.files;
                      if (files === null)
                        this.setState({ Query_Trigger_Document: null });
                      else this.setState({ Query_Trigger_Document: files[0] });
                    }}
                    disabled={
                      this.state.caseOutcome !==
                      constants.caseOutcome.inconclusive
                    }
                  />
                </Grid.Column>
                <Grid.Column>
                  <Form.Input
                    label="Repudiation Evidence"
                    disabled={
                      this.state.caseOutcome !==
                      constants.caseOutcome.repudiation
                    }
                    type="file"
                    multiple
                    accept="image/*, .pdf, .doc, .docx, .csv, .xls, .xlsx"
                    onChange={(e) => {
                      const files = e.target.files;
                      if (files === null) {
                        this.setState({ repudiationEvidence: [] });
                        return;
                      }
                      let a = [];
                      for (let i = 0; i < files.length; i++) a.push(files[i]);
                      this.setState({ repudiationEvidence: a });
                    }}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Button
                    positive
                    disabled={
                      this.state.form_investigators.findIndex((it) =>
                        it.getActive()
                      ) !== -1 ||
                      this.state.caseOutcome.trim().length === 0 ||
                      this.state.caseType.trim().length === 0 ||
                      this.state.report === null ||
                      (this.state.caseOutcome ===
                        constants.caseOutcome.repudiation &&
                        (this.state.repudiationEvidence.length === 0 ||
                          this.state.repudiation_Ground.length === 0)) ||
                      (this.state.caseOutcome ===
                        constants.caseOutcome.inconclusive &&
                        this.state.Query_Trigger_Document === null)
                    }
                    onClick={this.onSubmit}
                  >
                    Close (Initial Closure)
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Form>
        </Segment>

        <Modal
          size="tiny"
          open={this.state.changePopUp}
          onClose={() => this.setState({ changePopUp: false })}
          closeIcon
          closeOnDimmerClick={false}
          closeOnEscape={false}
        >
          <Modal.Header>Case Type Change Confirmation.</Modal.Header>
          <Modal.Content>
            <div>
              {/* {console.log(this.state.selectedCaseType, this.props.model.getType().getId(), "vvvvvvvvvvvvvv")} */}
              <br />
              <p>Do you want to change the case type?</p>
              <Button
                positive
                onClick={() => {
                  const caseType = this.getCaseTypeById(this.state.selectedCaseType);
                  const categoryCode = caseType?.getCaseCategoryCode() || this.state.newCaseCategoryCode;
                  
                  this.setState((prev) => {
                    return {
                      confirmation: !prev.confirmation,
                      changePopUp: !prev.changePopUp,
                      caseType: this.state.selectedCaseType,
                      caseTypeModel: caseType || this.state.caseTypeModel,
                      newCaseCategoryCode: categoryCode,
                      closeCaseTypeModel:
                        this.shouldRenderCaseOptionalFieldsInput(
                          this.state.selectedCaseType
                        ),
                    };
                  });
                }}
              >
                yes
              </Button>
              <Button
                negative
                onClick={() => this.setState({ changePopUp: false })}
              >
                No
              </Button>
            </div>
          </Modal.Content>
        </Modal>

        <Modal
          size="tiny"
          open={this.state.closeCaseTypeModel}
          closeIcon
          onClose={() =>
            this.setState((prev) => {
              return {
                closeCaseTypeModel: !prev.closeCaseTypeModel,
              };
            })
          }
          closeOnDimmerClick={false}
          closeOnEscape={false}
        >
          <Modal.Header>Case Required Fields</Modal.Header>
          <Modal.Content>
            <CaseOptionalFieldsInputForm
              model={this.props.model}
              caseType={this.state.caseTypeModel}
              onSuccess={this.props.updateModel}
            />
          </Modal.Content>
        </Modal>

        {/* Generate Report Modal */}
        <Modal
          size="small"
          open={this.state.generateReportModalOpen}
          onClose={this.closeGenerateReportModal}
          closeIcon
          closeOnDimmerClick={false}
          closeOnEscape={false}
        >
          <Modal.Header>Generate Report</Modal.Header>
          <Modal.Content>
            <Grid columns={2} divided>
              <Grid.Row>
                {/* Left Side - Treatment Type */}
                <Grid.Column>
                  <Header as="h4">Treatment Type</Header>
                  <Form>
                    <Form.Field>
                      <Radio
                        label={constants.treatmentType.surgical}
                        checked={this.state.treatmentTypeSurgical}
                        onChange={(_, data) =>
                          this.setState({ 
                            treatmentTypeSurgical: data.checked as boolean,
                            treatmentTypeConservative: false
                          })
                        }
                      />
                    </Form.Field>
                    <Form.Field>
                      <Radio
                        label={constants.treatmentType.conservative}
                        checked={this.state.treatmentTypeConservative}
                        onChange={(_, data) =>
                          this.setState({ 
                            treatmentTypeConservative: data.checked as boolean,
                            treatmentTypeSurgical: false
                          })
                        }
                      />
                    </Form.Field>
                  </Form>
                </Grid.Column>

                {/* Right Side - Diagnosis */}
                <Grid.Column>
                  <Header as="h4">Diagnosis</Header>
                  <Form>
                    {/* Acute Diagnosis */}
                    <Form.Field>
                      <Radio
                        label="Acute"
                        checked={this.state.diagnosisAcuteChecked}
                        onChange={(_, data) =>
                          this.setState({
                            diagnosisAcuteChecked: data.checked as boolean,
                            diagnosisChronicChecked: false,
                            selectedAcuteDiagnosis: data.checked ? this.state.selectedAcuteDiagnosis : "",
                            selectedAcuteDiagnosisObj: data.checked ? this.state.selectedAcuteDiagnosisObj : null,
                            selectedChronicDiagnosis: "",
                            selectedChronicDiagnosisObj: null,
                          })
                        }
                      />
                    </Form.Field>
                    {this.state.diagnosisAcuteChecked && (
                      <Form.Field>
                        <Form.Dropdown
                          placeholder="Select Acute Diagnosis"
                          search
                          selection
                          loading={this.state.loadingDiagnosis}
                          options={this.state.diagnosisList
                            .filter((item) => item.diagnosis_type === constants.diagnosis.acqute)
                            .map((item) => ({
                              key: item._id || item.diagnosis,
                              text: item.diagnosis,
                              value: item.diagnosis,
                            }))}
                          value={this.state.selectedAcuteDiagnosis}
                          onChange={(_, { value }) => {
                            const selectedItem = this.state.diagnosisList.find(
                              (item) => item.diagnosis === value && item.diagnosis_type === constants.diagnosis.acqute
                            );
                            console.log("Acute diagnosis item found:", selectedItem);
                            this.setState({
                              selectedAcuteDiagnosis: value as string,
                              selectedAcuteDiagnosisObj: selectedItem || null,
                            });
                          }}
                        />
                      </Form.Field>
                    )}

                    {/* Chronic Diagnosis */}
                    <Form.Field style={{ marginTop: "15px" }}>
                      <Radio
                        label="Cronic"
                        checked={this.state.diagnosisChronicChecked}
                        onChange={(_, data) =>
                          this.setState({
                            diagnosisChronicChecked: data.checked as boolean,
                            diagnosisAcuteChecked: false,
                            selectedChronicDiagnosis: data.checked ? this.state.selectedChronicDiagnosis : "",
                            selectedChronicDiagnosisObj: data.checked ? this.state.selectedChronicDiagnosisObj : null,
                            selectedAcuteDiagnosis: "",
                            selectedAcuteDiagnosisObj: null,
                          })
                        }
                      />
                    </Form.Field>
                    {this.state.diagnosisChronicChecked && (
                      <Form.Field>
                        <Form.Dropdown
                          placeholder="Select Cronic Diagnosis"
                          search
                          selection
                          loading={this.state.loadingDiagnosis}
                          options={this.state.diagnosisList
                            .filter((item) => item.diagnosis_type === constants.diagnosis.cronic)
                            .map((item) => ({
                              key: item._id || item.diagnosis,
                              text: item.diagnosis,
                              value: item.diagnosis,
                            }))}
                          value={this.state.selectedChronicDiagnosis}
                          onChange={(_, { value }) => {
                            const selectedItem = this.state.diagnosisList.find(
                              (item) => item.diagnosis === value && item.diagnosis_type === constants.diagnosis.cronic
                            );
                            console.log("Chronic diagnosis item found:", selectedItem);
                            this.setState({
                              selectedChronicDiagnosis: value as string,
                              selectedChronicDiagnosisObj: selectedItem || null,
                            });
                          }}
                        />
                      </Form.Field>
                    )}
                  </Form>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.closeGenerateReportModal}>Cancel</Button>
            <Button
              primary
              onClick={() => this.handleReportGenerate(this.props.model.getId())}
              loading={this.state.downloading}
              disabled={this.isGenerateButtonDisabled()}
            >
              Generate Report
            </Button>
          </Modal.Actions>
        </Modal>
      </Segment>
    );
  }

  /**
   * Converts CaseType[] to DropdownItemProps[]
   *
   * @param {CaseType[]} caseTypes
   * @returns {DropdownItemProps[]}
   */
  private toCaseTypeOptions = (caseTypes: CaseType[]) => {
    const options: DropdownItemProps[] = caseTypes.map((it) => {
  
      return { key: it.getId(), value: it.getId(), text: it.getTitle() };
    });
    return options;
  };

  /**
   * Converts string[] to DropdownItemProps[]
   *
   * @param {string[]} outcomeArray
   * @returns {DropdownItemProps[]}
   */
  private toOutcomeOptions = (outcomeArray: string[]) => {
    const options: DropdownItemProps[] = outcomeArray.map((it) => {
      return { key: it, value: it, text: it };
    });
    return options;
  };

  /**
   * Check whether case's field input form should render
   * or not on case type change
   *
   * @param {CaseType} newCaseType
   * @returns {boolean}
   */
  private shouldRenderCaseOptionalFieldsInput = (castetypeid: string) => {
    let caseTypeObj = this.state.caseTypes.find(
      (o) => o.getId().toString() == castetypeid.toString()
    );

    if (!caseTypeObj) {
      return false;
    }

    let model = this.props.model;
    const newCategoryCode = caseTypeObj.getCaseCategoryCode();

    // Always update the category code when case type changes
    if (this.state.newCaseCategoryCode !== newCategoryCode) {
      this.setState({
        newCaseCategoryCode: newCategoryCode,
      });
    }

    if (this.state.newCaseCategoryCode == newCategoryCode) {
      return false;
    }
    if (
      model.getInsuredLocation() === null ||
      model.getInsuredAddress() === null ||
      model.getInsuredContact() === null
    ) {
      return true;
    }

    return false;
  };

  /**
   * Find CaseType by id
   *
   * @param {string} caseTypeId
   * @return {CaseType | null}
   */
  private getCaseTypeById = (caseTypeId: string) => {
    const index = this.state.caseTypes.findIndex(
      (it) => it.getId() === caseTypeId
    );
    

    if (index === -1) return null;
    return this.state.caseTypes[index];
  };
}

const InvestigatorsLoadingState = () => {
  return (
    <React.Fragment>
      <Segment>
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column>
              <Placeholder>
                <Placeholder.Line />
                <Placeholder.Line />
              </Placeholder>
            </Grid.Column>

            <Grid.Column>
              <Placeholder>
                <Placeholder.Line />
                <Placeholder.Line />
              </Placeholder>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>

      <Segment>
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column>
              <Placeholder>
                <Placeholder.Line />
                <Placeholder.Line />
              </Placeholder>
            </Grid.Column>

            <Grid.Column>
              <Placeholder>
                <Placeholder.Line />
                <Placeholder.Line />
              </Placeholder>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </React.Fragment>
  );
};

export default (props: any) => {
  return (
    <RequirePermission permission={permissions.Case.fold}>
      <ActionFold {...props} />
    </RequirePermission>
  );
};
